import { Component } from '@angular/core';
import { IzzyCredentialExtensionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Credential Extensions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzycredentialextension-form',
    templateUrl: './izzycredentialextension.form.component.html'
})
export class IzzyCredentialExtensionFormComponent extends BaseFormComponent {
    public record!: IzzyCredentialExtensionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'credentialExtensionDetails', sectionName: 'Credential Extension Details', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

